'use client';

import { Tabs } from '@base-ui/react/tabs';
import { useState } from 'react';

import type { SidebarItem } from '../../../../../types';
import { PanelBody } from '../panel-body';
import './sidebar-panel.scss';

type SidebarPanelProps = {
    items: SidebarItem[];
    selectionPath: string[];
};

export function SidebarPanel({ items, selectionPath }: Readonly<SidebarPanelProps>) {
    const [activeItemId, setActiveItemId] = useState(items[0]?.id);

    return (
        <Tabs.Root
            value={activeItemId}
            onValueChange={setActiveItemId}
            orientation="vertical"
            className="sidebar-panel sparky-u-display-flex sparky-u-width-100"
        >
            <Tabs.List aria-label="Submenu categories" className="sidebar-panel__tabs">
                {items.map(item => (
                    <Tabs.Tab
                        key={item.id}
                        value={item.id}
                        nativeButton={!item.panel.overviewLink}
                        render={
                            item.panel.overviewLink ? (
                                // biome-ignore lint/a11y/useAnchorContent: Tabs.Tab merges its children (item.label) into this element at render time.
                                <a // NOSONAR — Tabs.Tab merges its children (item.label) into this element at render time.
                                    href={item.panel.overviewLink.href}
                                    rel={item.panel.overviewLink.openInNewTab ? 'noopener noreferrer' : undefined}
                                    target={item.panel.overviewLink.openInNewTab ? '_blank' : undefined}
                                    aria-label={item.label}
                                />
                            ) : undefined
                        }
                        className="sidebar-panel__tab sparky-u-theme-typography-body-lg-bold"
                        onMouseEnter={() => setActiveItemId(item.id)}
                    >
                        {item.label}
                    </Tabs.Tab>
                ))}
            </Tabs.List>

            {items.map(item => (
                <Tabs.Panel key={item.id} value={item.id} className="sidebar-panel__panel">
                    <PanelBody
                        panel={item.panel}
                        selectionPath={[...selectionPath, item.label]}
                        showOverviewLink={false}
                    />
                </Tabs.Panel>
            ))}
        </Tabs.Root>
    );
}
